import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEn150: CultureInfo = {
  name: 'en-150',
  displayName: 'English (Europe)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-150',
  parent: CultureInfoEn
};
